import { useEffect, useState } from "react";
import { X, Moon, Siren } from "lucide-react";
import { http } from "../lib/api";
import { DateInput } from "./DateInput";

const fmt = (iso) => new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });

export const NotifJournal = ({ onClose }) => {
  const [f, setF] = useState({ start: "", end: "", q: "" });
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => http.get("/notifications/journal", { params: Object.fromEntries(Object.entries(f).filter(([, v]) => v)) }).then((r) => setRows(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [f]);
  const ipt = "border border-slate-300 rounded-md px-2 py-1.5 text-sm";
  return (
    <div className="fixed inset-0 z-[90] bg-slate-900/40 backdrop-blur-sm grid place-items-center p-3" onClick={onClose}>
      <div className="bg-white rounded-xl w-full max-w-5xl max-h-[88vh] flex flex-col text-slate-800" onClick={(e) => e.stopPropagation()} data-testid="notif-journal">
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
          <h3 className="font-display text-lg font-bold">Journal des alertes</h3>
          <button onClick={onClose} className="p-1 rounded hover:bg-slate-100" data-testid="notif-journal-close"><X className="h-4 w-4" /></button>
        </div>
        <div className="flex flex-wrap gap-2 px-5 py-3 border-b border-slate-100">
          <DateInput value={f.start} onChange={(e) => setF({ ...f, start: e.target.value })} className={ipt} data-testid="notif-journal-start" />
          <DateInput value={f.end} onChange={(e) => setF({ ...f, end: e.target.value })} className={ipt} data-testid="notif-journal-end" />
          <input value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="Destinataire ou objet" className={`${ipt} flex-1 min-w-[180px]`} data-testid="notif-journal-search" />
        </div>
        <div className="overflow-auto">
          <table className="w-full text-sm" data-testid="notif-journal-table">
            <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500 sticky top-0">
              <tr><th className="text-left px-4 py-2">Date</th><th className="text-left px-4 py-2">Destinataire</th><th className="text-left px-4 py-2">Alerte</th><th className="text-left px-4 py-2">Envoi</th><th className="text-left px-4 py-2">Lue</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-center text-slate-500">Aucune alerte sur la période.</td></tr>}
              {rows.map((r) => (
                <tr key={r.id} data-testid={`notif-journal-row-${r.id}`}>
                  <td className="px-4 py-2 whitespace-nowrap">{fmt(r.created_at)}</td>
                  <td className="px-4 py-2">{r.recipient || "—"} <span className="text-[10px] text-slate-400">{r.recipient_type === "agent" ? "agent" : "utilisateur"}</span></td>
                  <td className="px-4 py-2">{r.urgent && <Siren className="inline h-3.5 w-3.5 text-rose-600 mr-1" />}{r.title}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{r.mode === "silent" ? <span className="inline-flex items-center gap-1 text-indigo-700"><Moon className="h-3.5 w-3.5" />Silencieuse</span> : "Normale"} <span className="text-[10px] text-slate-400">{r.devices ? `${r.devices} appareil(s)` : "cloche seule"}</span></td>
                  <td className="px-4 py-2">{r.read === null || r.read === undefined ? "—" : r.read ? "Oui" : "Non"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
